module.exports = __webpack_public_path__ + "pe-icon-set-weather.64b3045155488824398a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/assets/fonts/pe/fonts/pe-icon-set-weather.woff?nlruav
// module id = ../../../../../src/assets/fonts/pe/fonts/pe-icon-set-weather.woff?nlruav
// module chunks = styles